import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { LoadingButton, SectionTitle } from 'components';
import FullPageSyncLoader from 'components/FullPageSyncLoader';
import I18n from 'i18n-js';
import Button from 'components/Button/Button';
import { navigate } from 'navigation';

import mensajesRecordatoriosService from 'services/remote/MensajeRecordatorioService';
import MensajeRecordatorios from 'types/models/mensajes-recordatorios';

import styles from './tarifa-detalles-inscritos.module.scss';

interface ParameterDetalles {
  mensajeRecordatorioID: string;
}

export const MensajeRecordatorioDetalles = (): JSX.Element => {
  const [loadingData, setLoadingData] = useState(true);
  const [saving, setSaving] = useState(false);
  const { mensajeRecordatorioID } = useParams<ParameterDetalles>();
  const [mensajeRecordatorio, setMensajeRecordatorio] = useState<MensajeRecordatorios | null>(null);

  const [recipientesCc, setRecipientesCc] = useState('');
  const [textoPlano, setTextoPlano] = useState('');
  const [html, setHtml] = useState('');

  useEffect(() => {
    mensajesRecordatoriosService
      .getById(+mensajeRecordatorioID)
      .then((response) => {
        setMensajeRecordatorio(response);
        setRecipientesCc(response.listadoRecipientesCc?.join(', ') || '');
        setTextoPlano(response.plantillaTextoPlano || '');
        setHtml(response.plantillaHtml || '');
      })
      .finally(() => setLoadingData(false));
  }, [mensajeRecordatorioID]);

  const handleSave = async () => {
    if (!mensajeRecordatorio) return;
    setSaving(true);
    try {
      await mensajesRecordatoriosService.updateById(mensajeRecordatorio.id, {
        listado_recipientes_cc: recipientesCc.split(',').map((r) => r.trim()),
        plantilla_texto_plano: textoPlano,
        plantilla_html: html,
      });
      alert(I18n.t('Guardado correctamente'));
    } catch (error) {
      console.error(error);
      alert(I18n.t('Error al guardar'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={styles.root}>
      {loadingData ? (
        <FullPageSyncLoader icon />
      ) : (
        <>
          <Button
            className={styles.viewmore_button}
            variant="tertiary"
            type="button"
            onClick={() => navigate('/tecnic/onboarding/mensajes-recordatorios')}
            text={I18n.t('UsersPage.back')}
          />

          <form className={styles.form}>
            {mensajeRecordatorio && (
              <div className={styles.recordatorioDetalleContainer}>
                <div className={styles.postflex}>
                  <SectionTitle text={`${I18n.t('Paso')}: ${mensajeRecordatorio.pasoNombre}`} />
                </div>

                <div className={styles.section}>
                  <div className={styles.datosSolicitud}>
                    <label htmlFor="recipientesCc">{I18n.t('Destinatarios CC')}</label>
                    <input
                      id="recipientesCc"
                      type="text"
                      value={recipientesCc}
                      onChange={(e) => setRecipientesCc(e.target.value)}
                      className={styles.input}
                    />

                    <label htmlFor="textoPlano">{I18n.t('Texto plano')}</label>
                    <textarea
                      id="textoPlano"
                      value={textoPlano}
                      onChange={(e) => setTextoPlano(e.target.value)}
                      className={styles.textarea}
                      rows={6}
                    />

                    <label htmlFor="htmlContent">HTML</label>
                    <textarea
                      id="htmlContent"
                      value={html}
                      onChange={(e) => setHtml(e.target.value)}
                      className={styles.textarea}
                      rows={10}
                    />

                    <div className={styles.htmlRenderPreview}>
                      <p className={styles.previewLabel}>{I18n.t('Vista previa HTML')}</p>
                      <div className={styles.previewBox} dangerouslySetInnerHTML={{ __html: html }} />
                    </div>

                    <div className={styles.actions}>
                      <Button
                        type="button"
                        onClick={(): Promise<void> => navigate('/tecnic/mensajes-recordatorios')}
                        variant="secondary"
                        text={I18n.t('Cancel')}
                      />
                      <LoadingButton type="submit" text={I18n.t('Save')} onClick={handleSave} loading={saving} />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </form>
        </>
      )}
    </div>
  );
};
